import React, { Component } from "react";

import {
  CButton,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import ApplicatedQuestionItemsMenu from "./ApplicatedQuestionItemsMenu/ApplicatedQuestionItemsMenu";
import { logout } from "../../../actions/baseActions";
import { showHelpdesk } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import TextEditor from "../../TextEditor/TextEditor";
import TextEditorReadOnly from "../../TextEditorReadOnly/TextEditorReadOnly";
import QuestionCreator from "../QuestionCreator";

import "./styles.css";

const EditWarningModal = props => (
  <CModal
    show={props.show}
    color="warning"
    centered
    onClose={() => props.onClose()}
    closeOnBackdrop={false}
    className="toShow"
  >
    <CModalHeader closeButton>Atenção</CModalHeader>
    <CModalBody>
      <p>
        Essa questão está em uma prova já aplicada e não é possível editá-la.
      </p>
    </CModalBody>
    <CModalFooter>
      <CButton color="secondary" onClick={() => props.onClose()}>
        Cancelar
      </CButton>
    </CModalFooter>
  </CModal>
);

const DeleteModal = props => (
  <CModal
    color="danger"
    show={props.show}
    centered
    onClose={() => props.onClose()}
    closeOnBackdrop={false}
    className="toShow"
  >
    <CModalHeader closeButton>Confirmação de exclusão</CModalHeader>
    <CModalBody>
      <div className="p-2">
        <p>Tem certeza que deseja apagar a questão?</p>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="danger" onClick={() => props.onDelete()}>
        Confirmar
      </CButton>
      <CButton color="secondary" onClick={() => props.onClose()}>
        Cancelar
      </CButton>
    </CModalFooter>
  </CModal>
);

const InfoModal = props => (
  <CModal
    show={props.show}
    centered
    onClose={() => props.onClose()}
    closeOnBackdrop={false}
    className="toShow"
  >
    <CModalHeader closeButton>Informações sobre a questão</CModalHeader>
    <CModalBody>
      <div>
        <strong>ID: </strong>
        {props.info?.id}
      </div>
      <div>
        <strong>Eixo temático BNCC: </strong>
        {props.info?.module_name || "Sem módulo cadastrado"}
      </div>
      <div>
        <strong>Habilidade: </strong>
        {props.info?.ability_name
          ? `(${props.info?.ability_code}) ${props.info?.ability_name}`
          : "Sem habilidade cadastrada"}
      </div>
      <div>
        <strong>Privada: </strong>
        {props.info?.private ? "Sim" : "Não"}
      </div>
      <div>
        <strong>Ano: </strong>
        {props.info?.year}
      </div>
      <div>
        <strong>Dificuldade: </strong>
        {props.info?.difficulty_level_name}
      </div>
      <div>
        <strong>Tipo: </strong>
        {props.info?.type_question_name}
      </div>
    </CModalBody>
  </CModal>
);

class ApplicatedQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,

      id: undefined,
      typeId: 1,
      renderedtype: undefined,
      questionDescription: undefined,
      author: undefined,
      year: undefined,
      userId: undefined,
      items: [],
      questionFeedback: undefined,
      questionFeedbackOn: false,
      released: false,
      editable: false,
      questionInfo: null,
      infoModal: false,
      editWarningModal: false,
      module: null,
      ability: null,
      difficulty: null,
      discipline: null,
      type: null,

      prototype: this.props.prototype,
      listApplication: this.props.listApplication,
      finished: this.props.finished || false,

      types: [
        {
          id: 1,
          name: "Discursiva"
        },
        {
          id: 2,
          name: "Múltipla Escolha"
        },
        {
          id: 3,
          name: "Múltipla Resposta"
        },
        {
          id: 4,
          name: "Verdadeiro ou Falso"
        }
      ],

      userAnswer: [],
      userTextAnswer: '[{"type":"paragraph","children":[{"text":""}]}]',
      answer: [],
      deleteModal: false
    };

    this.answerChanger = this.changeAnswer.bind(this);
    this.changeQuestionTextAnswer = this.changeTextAnswer.bind(this);
  }

  componentDidMount() {
    this.pullQuestion();
  }

  pullQuestion() {
    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ types: resp.data.data });
        }
      });

    axios
      .get(
        `${URL.api}evaluation/question/singleView/${this.props.questionId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          const feedbackOn =
            resp.data.data.feedback &&
            resp.data.data.feedback !==
              '[{"type":"paragraph","children":[{"text":""}]}]';

          const answer = resp.data.data.options.map(item => ({
            id: item.id,
            answer: item.check_value
          }));
          const userAnswer = resp.data.data.options.map(answer => ({
            id: answer.id,
            answer: false
          }));

          this.setState(
            () => ({
              loading: false,

              id: resp.data.data.id,
              typeId: resp.data.data.type_question_id,
              questionDescription: resp.data.data.description,
              userId: resp.data.data.user_id,
              author: resp.data.data.author,
              year: resp.data.data.year,
              items: resp.data.data.options,
              questionFeedback: resp.data.data.feedback,
              questionFeedbackOn: feedbackOn,
              questionInfo: resp.data.data,
              released: resp.data.data.released,
              ability: resp.data.data.ability_id,
              module: resp.data.data.module_id,
              discipline: resp.data.data.discipline_id,
              difficulty: resp.data.data.difficulty_level_id,
              type: resp.data.data.type_type_question_id,

              answer,
              userAnswer
            }),
            () => this.renderType()
          );
        }
      });
  }

  changeAnswer(itemId, newAnswer) {
    if (this.props.finished || this.state.finished) return;

    // eslint-disable-next-line react/no-access-state-in-setstate
    const newAnswerArray = this.state.userAnswer;
    const itemIndex = newAnswerArray.findIndex(item => item.id === itemId);
    newAnswerArray[itemIndex].answer = newAnswer;

    newAnswerArray.forEach((item, index) => {
      if (this.state.typeId === 2 && item.id !== itemId) {
        newAnswerArray[index].answer = false;
      }
    });

    const correction =
      // eslint-disable-next-line react/no-access-state-in-setstate
      JSON.stringify(this.state.answer) === JSON.stringify(newAnswerArray);
    const answerData = {
      textAnswer: "Sem resposta",
      itemsAnswer: {
        items: newAnswerArray.slice().map(item => item.id),
        answers: newAnswerArray
          .slice()
          .filter(item => item.answer)
          .map(item => item.id)
      }
    };

    if (this.state.listApplication)
      this.props.listAswerChanger(this.state.id, correction, answerData);
    // eslint-disable-next-line react/no-unused-state
    this.setState({ userAnswer: newAnswerArray, correction });
  }

  onSave(question, edit) {
    if (
      question.module_id === this.state.questionInfo?.module_id &&
      question.ability_id === this.state.questionInfo?.ability_id &&
      question.segment_id === this.state.questionInfo?.segment_id &&
      this.state.questionInfo?.discipline_id === question.discipline_id &&
      edit
    ) {
      this.setState({ editable: false }, () => this.pullQuestion());
    } else {
      this.props.onSave(question, edit);
    }
  }

  changeTextAnswer(newAnswer) {
    if (this.props.finished || this.state.finished) return;

    const strAnswer = JSON.stringify(newAnswer);
    const answerData = {
      textAnswer: strAnswer,
      itemsAnswer: {
        items: [],
        answers: []
      }
    };

    if (this.state.listApplication)
      this.props.listAswerChanger(this.state.id, true, answerData);
    this.setState({ userTextAnswer: strAnswer });
    localStorage.setItem(`question-${this.props.id}-answer`, newAnswer);
  }

  renderType() {
    const typeIndex = this.state.types.findIndex(
      type => type.id === this.state.typeId
    );
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ renderedtype: this.state.types[typeIndex].name });
  }

  onDelete() {
    const obj = {
      id: this.props.questionId
    };

    this.setState({ deleteModal: false });

    axios
      .post(`${URL.api}evaluation/question/delete`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Questão excluída com sucesso!");
          this.props.onDelete();
        }
      });
  }

  render() {
    const canEdit =
      !this.props.questionId ||
      this.props.user.user.id === this.state.userId ||
      this.props.general.active_roles.role_id === 1;

    return (
      <>
        <DeleteModal
          show={this.state.deleteModal}
          onClose={() => this.setState({ deleteModal: false })}
          onDelete={() => this.onDelete()}
        />
        <EditWarningModal
          show={this.state.editWarningModal}
          onClose={() => this.setState({ editWarningModal: false })}
        />
        <InfoModal
          show={this.state.infoModal}
          onClose={() => this.setState({ infoModal: false })}
          info={this.state.questionInfo}
        />
        {this.state.editable ? (
          <QuestionCreator
            onActivity={false}
            questionValue={0}
            questionValueChanger={() => null}
            questionId={this.props.questionId}
            questionInfo={this.state.questionInfo}
            index={0}
            listChanger={() => null}
            questionDuplicator={() => null}
            questionDeleter={() => null}
            history={this.props.history}
            types={this.state.types}
            abilities={[]}
            onSave={(q, e) => this.onSave(q, e)}
            ability={this.state.ability}
            segment={this.props.segment}
            module={this.state.module}
            filter={{
              difficulty: this.state.difficulty,
              discipline: this.state.discipline,
              type: this.state.type
            }}
          />
        ) : (
          <>
            {!this.state.loading ? (
              <div
                className={`applicated-question-container m-0 ${
                  this.props.className || ""
                }`}
              >
                <section className="applicated-question-idetification-section">
                  <section className="applicated-question-source-year-section">
                    <p>
                      {this.state.renderedtype} - {this.state.id} (
                      {this.state.author && `${this.state.author}, `}
                      {this.state.year}) | Habilidade:{" "}
                      {this.state.questionInfo.ability_code}
                    </p>
                    <span></span>
                  </section>
                  <p className="applicated-question-type-indicator d-flex align-items-center">
                    <CDropdown className="ml-3">
                      <CDropdownToggle
                        color="white"
                        className="card-header-action remove-caret"
                      >
                        <i className="fa fa-ellipsis-v"></i>
                      </CDropdownToggle>
                      <CDropdownMenu placement="bottom-start">
                        <CDropdownItem
                          onClick={() => this.setState({ infoModal: true })}
                        >
                          Mais informações
                        </CDropdownItem>
                        <hr className="my-2" />
                        <CDropdownItem
                          onClick={() =>
                            this.props.showHelpdesk(
                              25,
                              this.props.questionId,
                              this.props.listId
                            )
                          }
                        >
                          Reportar erro
                        </CDropdownItem>
                        {canEdit && (
                          <>
                            <hr className="my-2" />
                            <CDropdownItem
                              onClick={() => {
                                if (this.state.released) {
                                  this.setState({ editWarningModal: true });
                                } else {
                                  this.setState({ editable: true });
                                }
                              }}
                            >
                              Editar
                            </CDropdownItem>
                            <CDropdownItem
                              className="text-danger"
                              onClick={() =>
                                this.setState({ deleteModal: true })
                              }
                            >
                              Excluir
                            </CDropdownItem>
                          </>
                        )}
                      </CDropdownMenu>
                    </CDropdown>
                  </p>
                </section>
                <TextEditorReadOnly
                  editorType={{ name: "description", id: 1 }}
                  questionId={this.props.questionId}
                  textContent={this.state.questionDescription}
                />
                {this.state.typeId === 1 ? (
                  <TextEditor
                    editorType={{ name: "answer", id: 4 }}
                    questionId={this.state.id}
                    changeQuestionTextAnswer={this.changeQuestionTextAnswer}
                    textContent={this.state.userTextAnswer}
                  />
                ) : (
                  <ApplicatedQuestionItemsMenu
                    questionType={this.state.typeId}
                    items={this.state.items}
                    userAnswer={this.state.userAnswer}
                    answerChanger={this.answerChanger}
                    finished={this.props.finished || this.state.finished}
                  />
                )}
                {(this.props.finished || this.state.finished) &&
                  this.state.questionFeedbackOn && (
                    <TextEditorReadOnly
                      editorType={{ name: "feedback", id: 2 }}
                      questionId={this.props.questionId}
                      textContent={this.state.questionFeedback}
                    />
                  )}
                {this.state.prototype && (
                  <section className="applicated-question-prototype-edit-finish-section">
                    {!this.state.finished ? (
                      <React.Fragment>
                        <button
                          className="finish-applicated-question-button"
                          onClick={() => this.setState({ finished: true })}
                        >
                          <i className="fa fa-check mr-2"></i>
                          <p>Mostrar resposta</p>
                        </button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <button
                          className="edit-applicated-question-button"
                          onClick={() => this.setState({ finished: false })}
                        >
                          <p>Voltar</p>
                        </button>
                      </React.Fragment>
                    )}
                  </section>
                )}
              </div>
            ) : (
              <div
                className={`applicated-question-container m-0 ${
                  this.props.className || ""
                }`}
              >
                <div className="d-flex justify-content-between">
                  <div
                    className="applicated-question-skeleton"
                    style={{ width: "28%", height: "1rem", margin: "8px 0" }}
                  />
                  <div
                    className="applicated-question-skeleton"
                    style={{ width: "32%", height: "1rem", margin: "8px 0" }}
                  />
                </div>
                <div className="my-2">
                  <div
                    className="applicated-question-skeleton"
                    style={{ width: "90%", height: "1.5rem", margin: "8px 0" }}
                  />
                  <div
                    className="applicated-question-skeleton"
                    style={{ width: "30%", height: "1.5rem", margin: "8px 0" }}
                  />
                </div>
                <div
                  className="applicated-question-skeleton"
                  style={{ width: "100%", height: "8rem", margin: "8px 0" }}
                />
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, showHelpdesk }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicatedQuestion);
